
import { authHeader } from '../helpers';
import store from '@/store';

const endpointLookup = {
  art_forms: 'art_form',
  art_media: 'art_medium',
  art_styles: 'art_style',
  art_subjects: 'art_subject',
  shipping_methods: 'shipping_method',
};

export const apiService = {
  addArt,
  updateArt,
  getArt,
  getPiece,
  getArtist,
  getArtists,
  getDashboard,
  getOrderLines,
  confirmOrderLine,
  addItem,
  deletePiece,
  updateItem,
  getItems,
  wasteMyTime,
  reportFault,
  getShippingMethods,
  getResource,
  addOrder,
  getAddresses,
  getPayout,
  getPayouts,
  getRental,
  getRentals,
  toggleAway,
  confirmReturn,
  getFilters,
};
function getFilters() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/filter`, requestOptions).then(handleResponse);
}
// Item functions
function toggleAway(artistId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/away`, requestOptions).then(handleResponse);
}
function getAddresses() {
  return fetch('https://ams3.digitaloceanspaces.com/wall.res/resources/addresses.json').then(handleResponse);
}
function getArt(filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  let statusString = '';
  if (filter.status) {
    statusString = filter.status.join('&status[]=');
  }
  return fetch(`
  ${process.env.ROOT_API}/art?&artist_id=${filter.artist_id || ''}${statusString ? `&status[]=${statusString}` : ''}&is_test=${filter.is_test || ''}`,
  requestOptions).then(handleResponse);
}
function getPiece(pieceId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/art/${pieceId}`, requestOptions).then(handleResponse);
}
function getDashboard() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/dashboard`, requestOptions).then(handleResponse);
}
function deletePiece(profileId, id) {
  const requestOptions = {
    method: 'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${profileId}/art/${id}`, requestOptions).then(handleResponse);
}
function getArtist(artistId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}`, requestOptions).then(handleResponse);
}
function getArtists() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/preview/all`, requestOptions).then(handleResponse);
}
async function addArt(profileId, form) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/artist/${profileId}/art`, requestOptions).then(handleResponse);
}
async function updateArt(profileId, form) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/artist/${profileId}/art/${form.id}`, requestOptions).then(handleResponse);
}
function getOrderLines(filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  let statusString = '';
  if (filter.status) {
    statusString = filter.status.join('&status[]=');
  }
  return fetch(`${process.env.ROOT_API}/order-line${statusString ? `?status[]=${statusString}` : ''}`, requestOptions).then(handleResponse);
}
async function confirmOrderLine(artistId, lineId) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/order-line/${lineId}/confirm`, requestOptions).then(handleResponse);
}
async function confirmReturn(id) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${id}/confirm-return`, requestOptions).then(handleResponse);
}
function getPayouts() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/payout`, requestOptions).then(handleResponse);
}
function getPayout(payoutId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/payout/${payoutId}`, requestOptions).then(handleResponse);
}
function getRental(rentalId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${rentalId}`, requestOptions).then(handleResponse);
}
function getRentals(filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  let statusString = '';
  if (filter.status) {
    statusString = filter.status.join('&status[]=');
  }
  return fetch(`${process.env.ROOT_API}/rental${statusString ? `?status[]=${statusString}` : ''}`, requestOptions).then(handleResponse);
}
function getItems() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/item`, requestOptions).then(handleResponse);
}
async function addItem(item) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(item),
  };
  return fetch(`${process.env.ROOT_API}/item`, requestOptions).then(handleResponse);
}
function updateItem(item) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(item),
  };
  return fetch(`${process.env.ROOT_API}/item`, requestOptions).then(handleResponse);
}
function wasteMyTime() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1000);
  });
}
async function reportFault(error) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(error),
  };
  return fetch(`${process.env.ROOT_API}/staff/fault`, requestOptions).then(handleResponse);
}
function getResource(resource) {
  const requestOptions = {
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const paramString = `${process.env.ROOT_API}/resource/${endpointLookup[resource] || resource}`;
  return fetch(paramString, requestOptions).then(handleResponse);
}
function getShippingMethods() {
  const shippingMethods = [
    {
      id: 1,
      carrier: 'DHL',
      title: 'Standard Economy',
      time: '3-5 Business Days',
      price: 120,
    },
    {
      id: 2,
      carrier: 'DHL',
      title: 'Overnight',
      time: '24 Hours',
      price: 500,
    },
  ];
  return shippingMethods;
}
async function addOrder(order) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(order),
  };
  return fetch(`${process.env.ROOT_API}/order`, requestOptions).then(handleResponse);
}

// Helper Functions
function handleResponse(response) {
  return response.text().then((text) => {
    const content = text && JSON.parse(text);
    if (!response.ok) {
      // Notify admin of issue
      // reportFault({ url: response.url, message: response.statusText });
      // auto logout if 401 response returned from api
      if (response.status === 401) {
        // INVALID USER GET HIM THE HELL OUT OF HERE!
        store.commit('account/logout');
        location.reload(true);
      }
      const error = (content && content.message) || response.statusText;
      return Promise.reject(error);
    }
    return Promise.resolve(content);
  });
}



// WEBPACK FOOTER //
// ./src/services/api.service.js